// Angular
import { RouterModule } from "@angular/router";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

// BBWT
import { GridModule } from "@features/grid";
import { FilterModule } from "@features/filter";
import { DynamicFormModule } from "@features/dynamic-form";
import { BbCardModule } from "@features/bb-card";
import { BbTooltipModule } from "@features/bb-tooltip";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { AccessDirectivesModule } from "@main/access-directives/access-directives.module";
import { RavenApiSettingsComponent } from "./components/raven-api-settings.component";
import { RavenApiService } from "../raven/raven-api.service"
import { RavenCategorySettingsComponent } from "./components/raven-category-settings.component";
import { RavenPriorityComponent } from "./components/raven-priority.component";
import { RavenPriorityService } from "@main/raven/raven-priority.service";
import { RavenCategoryService } from "../raven/raven-category.service";
import { RavenStatusComponent } from "./components/raven-status.component";
import { RavenStatusService } from "../raven/raven-status.service"
import { RavenControlComponent } from "./raven-control.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";

const routes = [
    {
        path: "api",
        component: RavenApiSettingsComponent,
        data: { title: "Raven Api Settings" }
    },
    {
        path: "category",
        component: RavenCategorySettingsComponent,
        data: { title: "Raven Category" }
    },
    {
        path: "priority",
        component: RavenPriorityComponent,
        data: { title: "Raven Priority" }
    },
    {
        path: "status",
        component: RavenStatusComponent,
        data: { title: "Raven Status" }
    }
];

@NgModule({
    declarations: [
        RavenApiSettingsComponent, RavenCategorySettingsComponent,
        RavenPriorityComponent, RavenStatusComponent, RavenControlComponent,
    ],
    imports: [
        CommonModule, FormsModule,
        PrimeNgModule,

        // BBWT
        GridModule, FilterModule, DynamicFormModule, BbCardModule, AccessDirectivesModule,
        BbTooltipModule, BbwtSharedModule, ReactiveFormsModule, MiproSharedModule,

        RouterModule.forChild(routes)
    ],
    providers: [RavenPriorityService, RavenCategoryService, RavenStatusService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [RavenControlComponent, ]
})
export class RavenModule { }